import React from 'react';

export default () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.25 3V9.25H6.75V1.75H13C13.6904 1.75 14.25 2.30964 14.25 3Z" stroke="#A2A2A8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3 1.75H4.25V4.25H1.75V3C1.75 2.30964 2.30964 1.75 3 1.75Z" stroke="#A2A2A8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M1.75 6.75H4.25V9.25H1.75V6.75Z" stroke="#A2A2A8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M1.75 13V11.75H4.25V14.25H3C2.30964 14.25 1.75 13.6904 1.75 13Z" stroke="#A2A2A8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M6.75 11.75H9.25V14.25H6.75V11.75Z" stroke="#A2A2A8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M13 14.25H11.75V11.75H14.25V13C14.25 13.6904 13.6904 14.25 13 14.25Z" stroke="#A2A2A8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);
